import { lazy } from "react";
import { Route } from "react-router-dom";
import { LazyRoute } from "./LazyRoute";

const FluencyEntryPage = lazy(() => import("@/features/fluency/pages/FluencyEntryPage"));
const FluencySessionPage = lazy(() => import("@/features/fluency/pages/FluencySessionPage"));

export const fluencyRoutes = (
  <>
    <Route
      path="/parent/fluency/start"
      element={
        <LazyRoute fallbackMessage="Loading reading session...">
          <FluencyEntryPage />
        </LazyRoute>
      }
    />
    <Route
      path="/parent/fluency/session/:sessionId"
      element={
        <LazyRoute fallbackMessage="Loading reading session...">
          <FluencySessionPage />
        </LazyRoute>
      }
    />
  </>
);
